<template>
  <div class="" style="height: 100%" v-if="!loading">
    <iframe v-if="cpNum === 'fe559562bb2b456b848a545bb5d2eb4a' && isMap" src="https://www.qutgroup.com/fcweb/demo" frameborder="0" width="100%" height="100%"></iframe>

    <!-- :zoomEnable="false" -->
    <el-amap
      v-show="(cpNum === 'ae5d8c2a5ed7470c8b08fafa1524dfce' || cpNum === 'ee7a45afdd0540d59efc25eb7f3bde74') && isMap"
      class="amap-box"
      vid="amap"
      ref="centerMap"
      :zoom="17"
      :zooms="[16, 20]"
      :dragEnable="false"
      :zoomEnable="false"
      :amap-manager="amapManager"
      :resizeEnable="true"
      :center="position"
      :plugin="plugin"
      :events="events"
    >
      <el-amap-marker
        v-for="(marker, index) in markers"
        :position="marker.position"
        :events="marker.events"
        :visible="marker.visible"
        :draggable="marker.draggable"
        :label="marker.label"
        :vid="index"
        :key="index"
      ></el-amap-marker>
      <!-- 	left: 731px;
			    top: 300px; -->
      <el-amap-info-window
        :position="currentWindow.position"
        :content="currentWindow.content"
        :visible="currentWindow.visible"
        :events="currentWindow.events"
        :offset="[81, 0]"
      ></el-amap-info-window>

      <!-- <el-amap-marker vid="component-marker" :position="position" :icon="icon" v-if="isWaring"></el-amap-marker>
			
			<el-amap-marker
				:icon="warIcon"
				vid=""
				v-for="(item, index) of markers"
				:position="item.position"
				:events="item.loca"
				:animation="item.animate && aniIndex ? 'AMAP_ANIMATION_BOUNCE' : 'AMAP_ANIMATION_NONE'"
			></el-amap-marker>
			<el-amap-text
				:zIndex="99999"
				:visible="item.showmod || showmodall"
				v-for="item in markers"
				:text="item.text"
				:offset="[0, 30]"
				:position="item.position"
			></el-amap-text> -->

      <!-- <info @local="showpos"></info> -->
    </el-amap>
    <el-dialog :title="'提示'" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
      <el-tabs :value="dialogData.pingpicurl || dialogData.shupicurl">
        <el-tab-pane label="单层平面图" :name="dialogData.pingpicurl" v-if="dialogData.pingpicurl">
          <img :src="dialogData.pingpicurl" alt="" />
        </el-tab-pane>
        <el-tab-pane label="疏散演练图" :name="dialogData.shupicurl" v-if="dialogData.shupicurl">
          <img :src="dialogData.shupicurl" alt="" />
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <div v-show="currentWindow.visible" ref="info" class="info-window">
      <div class="info-window-cell" v-for="(item, index) in currentWindow.data" :key="index" @click="open(index)">
        {{ item.layer }}
      </div>
      <!-- <div class="info-window-cell">2f</div> -->
    </div>
    <three class="bim" @back="back" v-if="!isMap" />
  </div>

  <!--    <div class="" style="min-height:650px;height:100%">
        <iframe v-if="cpNum=='f22d1d6348b645e2b29fc08ab5a677f2' || cpNum=='ee7a45afdd0540d59efc25eb7f3bde74'  " src="https://www.qutgroup.com/fcweb/demo" frameborder="0" width="100%" height="100%"></iframe>
    </div> -->
</template>
<script>
import { AMapManager, lazyAMapApiLoaderInstance } from 'vue-amap';
let amapManager = new AMapManager();
import { getsmoke } from '../../api/facility';
import three from './three.vue';
export default {
  components: {
    three,
  },
  data() {
    return {
      dialogVisible: false,
      loading: true,
      dialogData: {},
      isMap: true,
      map: '',
      position: [120.4771, 36.15021],
      markPosition: [],
      // position: [116.364495, 39.930694],
      zoom: 18,
      amapManager,
      polygon: '',
      events: {
        init: (o) => {
          this.map = this.amapManager.getMap();
          o.getCity((result) => {
            console.log(result);
          });
        },
        moveend: () => {},
        zoomchange: () => {},
        click: (e) => {
          this.currentWindow.visible = false;
        },
      },
      plugin: [
        'ToolBar',
        {
          pName: 'MapType',
          defaultType: 1,
          events: {
            init(o) {
              console.log(o);
            },
          },
        },
      ],
      entryImg: require('@/assets/img/bim_img/entry.svg'),
      markers: [
        // {
        // 	position: [120.4771, 36.15021],
        // 	events: {
        // 		click: e => {
        // 			console.log(this, e, this.markers[+e.target.content]);
        // 			this.currentWindow.visible = true;
        // 			this.currentWindow.content = this.$refs.info;
        // 			this.currentWindow.position = [e.lnglat.lng, e.lnglat.lat];
        // 			// this.currentWindow.position = e
        // 		},
        // 		dragend: e => {
        // 			console.log('---event---: dragend');
        // 			this.markers[0].position = [e.lnglat.lng, e.lnglat.lat];
        // 		}
        // 	},
        // 	visible: true,
        // 	draggable: false,
        // 	label: { content: `哈哈哈哈哈<img src=""/>`, offset: [-24, 34] },
        // 	template: '<span>1</span>'
        // }
      ],
      currentWindow: {
        position: [120.48, 36.15],
        content: this.$refs.info,
        events: {},
        data: [],
        visible: false,
      },

      list: [],
    };
  },
  props: ['cpNum'],
  created() {
    // <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests" />
  },
  mounted() {
    setTimeout(() => {
      //此代码将http请求更改为https请求,故本地开发时需要将此代码注掉
      // 不开发此页面时可以无视!!!!!
      // var head = document.getElementsByTagName('head')[0];
      // var meta = document.createElement('meta');
      // meta.httpEquiv = 'Content-Security-Policy';
      // meta.content = 'upgrade-insecure-requests';
      // meta.id = 'bimHttp';
      // head.appendChild(meta);
      this.loading = false;
    });
    // this.getList()
  },
  beforeDestroy() {
    var meta = document.getElementById('bimHttp');

    // document.head.removeChild(meta)
    meta.parentNode.removeChild(meta);
  },
  watch: {
    cpNum() {
      //  this.getList()
      this.isMap = false;
      this.getList();
    },
    loading(v) {
      if (!v) {
        this.getList();
      }
    },
  },
  methods: {
    initMap() {
      setTimeout(() => {
        console.log(AMap);
        new AMap.DistrictSearch({
          extensions: 'all',
          subdistrict: 0,
        }).search('青岛市', (status, result) => {
          var options = {
            areas: [
              {
                // 围栏1
                // visible: false, // 是否可见
                rejectTexture: true, // 是否屏蔽自定义地图的纹理
                path: [
                  [
                    [120.4621, 36.15521],
                    [120.4921, 36.15521],
                    [120.4921, 36.14521],
                    [120.4621, 36.14521],
                  ],
                ],
              },
            ],
          };

          // 外多边形坐标数组和内多边形坐标数组
          var outer = [new AMap.LngLat(-360, 90, true), new AMap.LngLat(-360, -90, true), new AMap.LngLat(360, -90, true), new AMap.LngLat(360, 90, true)];
          var holes = result.districtList[0].boundaries;

          var pathArray = [outer];
          pathArray.push.apply(pathArray, options.areas[0].path);
          var polygon = new AMap.Polygon({
            path: pathArray,
            //线条颜色，使用16进制颜色代码赋值。默认值为#006600
            strokeColor: 'rgb(20,164,173)',
            strokeWeight: 4,
            //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
            strokeOpacity: 0.5,
            //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
            fillColor: 'rgba(0,0,0)',
            //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
            fillOpacity: 1,
            //轮廓线样式，实线:solid，虚线:dashed
            strokeStyle: 'dashed',
            /*勾勒形状轮廓的虚线和间隙的样式，此属性在strokeStyle 为dashed 时有效， 此属性在
				              ie9+浏览器有效 取值：
				              实线：[0,0,0]
				              虚线：[10,10] ，[10,10] 表示10个像素的实线和10个像素的空白（如此反复）组成的虚线
				              点画线：[10,2,10]， [10,2,10] 表示10个像素的实线和2个像素的空白 + 10个像素的实
				              线和10个像素的空白 （如此反复）组成的虚线*/
            strokeDasharray: [10, 2, 10],
          });
          polygon.setPath(pathArray);

          setTimeout(() => {
            console.log(this.map, AMap, polygon, pathArray);
            this.map.add(polygon);
            // this.map.on('click', e => {
            // 	console.log(e, 111111111111111);
            // 	console.log(e.lnglat.getLng(), e.lnglat.getLat());
            // });
          });
        });
      });
    },
    open(e) {
      this.dialogData = {};
      this.dialogVisible = true;
      setTimeout(() => {
        this.dialogData = this.currentWindow.data[e];
      });
    },
    getBimPic() {
      this.$get('/bim/bimPics/list').then((res) => {
        console.log(res);
        let markers = [],
          i = 0;
        res.rows.forEach((item) => {
          let is = markers.find((it, index) => {
            if (it.name == item.name) {
              i = index;
              return true;
            }
          });
          if (!is) {
            // console.log(is, item);
            let x = -item.name.length * 4.25;
            let a = markers.length ? i + 1 : i;
            console.log(a);
            markers.push({
              name: item.name,
              position: JSON.parse(item.data),
              info: [
                {
                  layer: item.layer,
                  shupicurl: item.shupicurl,
                  pingpicurl: item.pingpicurl,
                },
              ],
              events: {
                click: (e) => {
                  this.currentWindow.visible = true;
                  this.currentWindow.content = this.$refs.info;
                  this.currentWindow.position = JSON.parse(item.data);
                  this.currentWindow.data = markers[a].info;
                },
              },
              visible: true,
              draggable: false,
              label: {
                content: `${item.name}<img id="entry" style="width:20px;margin-left:6px;display:${item.name == '办公楼' ? '' : 'none'}" src="${this.entryImg}"/>`,
                offset: [x, 34],
              },
            });
          } else {
            markers[i].info.push({
              layer: item.layer,
              shupicurl: item.shupicurl,
              pingpicurl: item.pingpicurl,
            });
          }
        });
        this.isMap = true;
        console.log(markers);
        this.markers = markers;
        let clickEvent = () => {
          this.currentWindow.visible = false;
          this.dialogVisible = false;
          this.isMap = false;
        };
        let inter = setInterval(() => {
          if (document.getElementById('entry')) {
            document.getElementById('entry')?.removeEventListener('click', clickEvent);
            document.getElementById('entry')?.addEventListener('click', clickEvent);
            window.clearInterval(inter);
          }
        }, 100);
      });
    },
    back() {
      this.isMap = !this.isMap;
    },
    handleClose(done) {
      // this.$confirm('确认关闭？')
      // .then(_ => {
      done();
      // })
      // .catch(_ => {});
    },
    getList() {
      this.dialogVisible = false;
      this.isMap = true;
      var cNum = this.cpNum == 'ee7a45afdd0540d59efc25eb7f3bde74' ? 'fe559562bb2b456b848a545bb5d2eb4a' : this.cpNum;

      if (
        !(
          this.cpNum == 'fe559562bb2b456b848a545bb5d2eb4a' ||
          this.$store.state.user.company.cCompanyNum == 'fe559562bb2b456b848a545bb5d2eb4a' ||
          this.cpNum == 'ae5d8c2a5ed7470c8b08fafa1524dfce' ||
          this.cpNum == 'ee7a45afdd0540d59efc25eb7f3bde74' ||
          this.$store.state.user.company.cCompanyNum == 'ae5d8c2a5ed7470c8b08fafa1524dfce' ||
          this.$store.state.user.company.cCompanyNum == 'ee7a45afdd0540d59efc25eb7f3bde74'
        )
      ) {
        this.$message.warning('该业务尚未开通，请联系管理员');
      } else {
        this.initMap();
        this.getBimPic();
      }
    },
  },
};

//     data() {
//         return {
//             list:[]
//         }
//     },
//       props:['cpNum'],
//     created() {
//        this.getList()
//     },
//     mounted() {
//         // this.getList()
//     },
//         watch:{
//         cpNum(){
//             //  this.getList()
//             this.getList()
//         }
//     },
//     methods: {
//         getList(){
//        var cNum = this.cpNum=='ee7a45afdd0540d59efc25eb7f3bde74' ? 'f22d1d6348b645e2b29fc08ab5a677f2' : this.cpNum
//              if(cNum!=='f22d1d6348b645e2b29fc08ab5a677f2' && (this.$store.state.user.company.cCompanyNum!=='f22d1d6348b645e2b29fc08ab5a677f2' && this.$store.state.user.company.cCompanyNum!=='ee7a45afdd0540d59efc25eb7f3bde74') ){
//             this.$message.warning('该业务尚未开通，请联系管理员')
//         }
//         }
//     }
// }
</script>
<style scoped lang="scss">
::v-deep .amap-toolbar {
  display: none;
}
::v-deep .amap-info-content {
  padding: 0;
}
::v-deep .amap-marker-label {
  border: none;
}
::v-deep .amap-info-close {
  display: none;
}
::v-deep .bottom-center .amap-info-sharp {
  display: none;
}
.info-window-cell {
  text-align: center;
  padding: 4px 8px;
  // border-top: 1px solid #666;
  // border-bottom: 1px solid #666;
  border: 1px solid #666;
  cursor: pointer;
}
.bim {
  height: 100%;
  top: 0;
}
</style>
